import { HomeApp } from "./pages/Home";
export function App() {
  return <HomeApp />;
}
